import { render, staticRenderFns } from "./PhoneNumberBond.vue?vue&type=template&id=67764dc7&"
import script from "./PhoneNumberBond.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumberBond.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneNumberBond.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports